import styled from "styled-components";

const FormControl = styled.div`
  width: 100%;
  display: grid;
  grid-row-gap: 6px;
  grid-template-rows: auto auto;
  position: relative;
`;

export default FormControl;
